import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function CompanyStory() {
  return (
    <section id="story" data-testid="company-story-section" className="relative py-20 sm:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.32em] font-mono text-cyan-400 font-semibold">Unsere Geschichte</p>
          <h2 className="mt-4 font-bold tracking-tight leading-tight text-2xl sm:text-4xl lg:text-5xl text-white">
            Aus Frustration wurde <span className="text-cyan-400">Leidenschaft.</span>
          </h2>
          <div className="mt-7 space-y-5 text-slate-300/90 text-sm sm:text-base leading-relaxed font-light">
            <p>
              Unsere Reise begann mit dem eigenen Pool — geplant als Ruheoase im Garten.
              Doch kein Handwerker lieferte, was wir suchten. Also legten wir selbst Hand an.
            </p>
            <p>
              Heute entwickeln wir nach unzähligen Projekten Poolsteuerungen individuell
              in unserem Haus — maßgeschneidert auf Ihr Projekt.
            </p>
          </div>
          <blockquote className="mt-8 glass-card rounded-2xl p-6 relative">
            <Quote className="w-6 h-6 text-cyan-400 mb-3" />
            <p className="font-display font-semibold text-lg text-white leading-snug">
              „Man wächst mit seinen Aufgaben. Wir lassen Ihre Poolträume Wirklichkeit werden."
            </p>
            <footer className="mt-3 text-xs font-mono text-slate-500 tracking-wide notranslate" translate="no">— <span className="text-slate-300">the </span><span className="text-cyan-400">coolpool</span><span className="text-slate-300"> company GmbH</span></footer>
          </blockquote>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="spotlight-img relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_40px_100px_-30px_rgba(0,229,255,0.2)]">
            <img
              src="/images/cp-story.webp"
              alt="Gartenpool am Abend"
              className="w-full aspect-[3/2] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/70 via-transparent to-transparent" />
          </div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="absolute -bottom-8 -left-4 sm:-left-8 glass-card rounded-2xl p-5 bg-[#0A1526]/90 max-w-[220px]"
          >
            <div className="font-display font-extrabold text-3xl text-cyan-300">100%</div>
            <div className="text-xs text-slate-400 mt-1 leading-relaxed">Eigenentwicklung — jede Poolsteuerung entsteht in unserem Haus.</div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
